<template>
    <div style="background:#FFF;">
        <Header></Header>
        
        <section class="page-container" style="padding:0px;" @click="hideImage($event)" >
                <div id="ri-grid" class="ri-grid ri-grid-size-2" style="min-height:170px;">
                    <img class="ri-loading-image" src="/koreyomo/static/assets/images/loading.gif"/>
                    <ul id="thumbList" >
                        <li v-for="(item, index) in thumbnailList" :data-index=index>
                            <!-- <a :data-item="item.workId" :data-workCode="item.workCode" :data-bannerMonochromeImageUrl="item.bannerMonochromeImageUrl" :data-bannerSmallImageUrl="item.bannerSmallImageUrl" href="javascript:void(0)"><img :src="item.bannerSmallImageUrl" alt="Loading" style="height:50px;"/></a> -->
                            <a  :data-item="item.workId" :data-workCode="item.workCode" 
                                :data-bannerMonochromeImageUrl="item.bannerMonochromeImageUrl" 
                                :data-bannerSmallImageUrl="item.bannerSmallImageUrl" 
                                href="javascript:void(0)">
                                <img :src="item.bannerSmallImageUrl" class="img-fluid" alt="Loading"/>
                            </a>
                        </li>
                    </ul>
                </div>
            
            <section v-if="selectedThumbnailArea && !isMobile()" style="width:100%;margin:0 auto;background-color:#333;"> 
                <div class="row" style="margin:0;">
                    <div  id="image-div">
                        <div class="selected-thumbnail-left" style="max-height:200px">
                            <!-- <p>The image that has the callout and call out text</p> -->
                            <img :src="this.firstImage" class="img-fluid calloutImage" alt="Image">
                        </div>
                    </div>
                    <div id="button-div">
                        <div class="selected-thumbnail-right" style="height: 100%;display: flex;flex-direction: column;justify-content: center;">
                            <router-link :to="{ name: 'ResultOfRecommendation', query: { m: 1, workCode: selectedThumbnail.join() }}" :disabled="selectedThumbnail.length > 2  ?  false : true" v-bind:style="{ pointerEvents:selectedThumbnail.length > 2  ?  '' : 'none'}">
                                <button @click="sendAnalytics()" v-bind:style="{ cursor: selectedThumbnail.length > 2  ?  'pointer' : 'default'}" :disabled="selectedThumbnail.length > 2  ?  false : true" type="button" class="btn btn-custom">結果を見る</button>
                            </router-link>
                        </div>
                    </div>
                </div>
            </section> 
            <section v-if="selectedThumbnailArea && isMobile()" style="width:100%;margin:0 auto;"> 
                <div class="row" style="margin:0;">
                    <div  style="width:100%;text-align:center;background-color:#333;">
                        <div class="selected-thumbnail-right">
                            <router-link :to="{ name: 'ResultOfRecommendation', query: { m: 1, workCode: selectedThumbnail.join() }}" :disabled="selectedThumbnail.length > 2  ?  false : true" v-bind:style="{ pointerEvents:selectedThumbnail.length > 2  ?  '' : 'none'}">
                                <button v-bind:style="{ cursor: selectedThumbnail.length > 2  ?  'pointer' : 'default'}" :disabled="selectedThumbnail.length > 2  ?  false : true" type="button" class="btn btn-custom">結果を見る</button>
                            </router-link>
                        </div>
                    </div>
                    <div  style="width:100%;background-color:#333;" v-if="calloutImageDivMobile">
                        <div class="selected-thumbnail-left" style="max-height:200px">
                            <!-- <p>The image that has the callout and call out text</p> -->
                            <img :src="this.firstImage" alt="Image" class="img-fluid calloutImage" style="width:100%">
                        </div>
                    </div>
                    
                </div>
            </section> 

            <div id="basicModal" class="modal fade" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" ref="vuemodal" style="padding-right:-10px!important">
                <div class="modal-dialog modal-md" style="margin: 0 auto;width:100%;">
                    <div class="modal-content" style="background-color: transparent;border:none;"> 
                        <div class="modal-body">
                            <img id="modalImage" :src="topImages" style="margin: 0 auto;width: 100%;" class="img-responsive">
                        </div>
                        <div class="text-center" id="modalCloseButton">
                            <button @click="toStart()" type="button" class="btn btn-custom-dialog" data-dismiss="modal">はじめる</button>
                        </div>
                    </div>
                </div>
            </div>

            
        </section>

        
        
 
        
        <Footer></Footer>
        
    </div>
</template>

<script>
    import * as consts from '../constants';
    import Header  from "../components/Header";
    import Footer  from "../components/Footer";
    import * as Api from '../api/apies6.js';
    window.axios = require('axios');
    
    export default {
        name: 'Home',
        components:{
            Header,
            Footer
        },
        data () {
            return {
                thumbnailList: [],
                selectedThumbnail: [],
                selectedImagePriority:999,
                selectedThumbnailArea:false,
                topImages: '',
                cursor: 'default',
                imageList: [],
                firstImage: '',
                calloutImageDivMobile: false
            }
        },

        methods: {
            sendAnalytics: function(){
                this.gtagFunction(consts.HIT_TYPE.CLICK, consts.EVENT_CATEGORY.KOREYOMO,consts.EVENT_LABEL.DIAGNOSE,'no');
            },
            hideImage: function(e){
               if(e.target.className.includes('btn-custom') && this.isMobile()){
                    $('#mai_image').hide();
                }
                
            },
            shuffle : function(a) {
                for (let i = a.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [a[i], a[j]] = [a[j], a[i]];
                }
                return a;
            },
             worksThumbnailList:async function() {
                let api = new Api.KoreyomoApi(this.getApiConfig())
                let thumbnails = await api.worksThumbnailListGetAsync()

                let filteredThumbList = []

                for (let k of Object.keys(thumbnails.thumbnailList)) {
                    let item = thumbnails.thumbnailList[k]
                    if (!item.workCode.startsWith('d_')) {
                        filteredThumbList.push(item)
                    }
                }

                this.thumbnailList = this.shuffle(filteredThumbList);
                let allImages = await api.mAIImagesGetAsync(false)
                this.topImages = allImages['topImages'];
                this.initGridrotator();
                
                this.imageList = allImages;
                this.firstImage = allImages['topBalloonImage0'];
                this.calloutImageDivMobile = true;
                var loadedModalImage = document.getElementById("modalImage").complete;
                if(loadedModalImage){
                    $("#modalCloseButton").show();
                }
            },

            initGridrotator:function(){
                setTimeout(() => {
                    if(this.isOnlyMobile()){
                        $( '#ri-grid' ).gridrotator( {
                            rows : 6,
                            columns : 3,
                            maxStep : 2,
                            interval : 2000,
                            w1024 : {
                                rows : 6,
                                columns : 3
                            },
                            w768 : {
                                rows : 6,
                                columns : 3
                            },
                            w480 : {
                                rows : 6,
                                columns : 3
                            },
                            w320 : {
                                rows : 6,
                                columns : 3
                            },
                            w240 : {
                                rows : 6,
                                columns : 3
                            },
                        });
                    }
                    else{
                        $( '#ri-grid' ).gridrotator( {
                            rows : 5,
                            columns : 7,
                            maxStep : 2,
                            interval : 2000,
                            w1024 : {
                                rows : 5,
                                columns : 6
                            },
                            w768 : {
                                rows : 5,
                                columns : 5
                            },
                            w480 : {
                                rows : 6,
                                columns : 3
                            },
                            w320 : {
                                rows : 6,
                                columns : 3
                            },
                            w240 : {
                                rows : 6,
                                columns : 3
                            },
                        });
                    }
                    
                }, 0);
                
            },

            toStart:function(){
                this.selectedThumbnailArea = true;
                this.gtagFunction(consts.HIT_TYPE.CLICK, consts.EVENT_CATEGORY.KOREYOMO,consts.EVENT_LABEL.SITE_TOP,'no');
            },

            showWhenModalHidden: function(){
                this.selectedThumbnailArea = true;
            }
        },

        mounted: function (){
            $(this.$refs.vuemodal).on("hidden.bs.modal", this.showWhenModalHidden)
        },

        created:function () {
            // alert(containerWidth);
            document.title = "コレヨモ！ - 読後の感情を認識するマンガ人工知能『MAI』が、あなたの読みたいマンガをおすすめします。";
            document.getElementsByTagName('meta')["description"].content = "コレヨモ！は、マンガ人工知能MAIが読者の感情を10次元で認識して、今の気持ちに合いそうな作品をおすすめします。";
            var vm = this;
            vm.worksThumbnailList();
            $(".calloutImage").attr("src",vm.imageList['topBalloonImage0']);
            
            $(document).on("click","#ri-grid ul li a",function() {
                var totalMangas = totalRows*totalColumns;
                var workCode = $(this).attr("data-workCode");
                var index = $(this).parent().attr("data-index");
                var liHtml = $(this).parent('li');
                if( liHtml.hasClass('selectedThumb') || liHtml.hasClass('selectedThumbTopLeft') || 
                    liHtml.hasClass('selectedThumbTopRight') || liHtml.hasClass('selectedThumbTop')||
                    liHtml.hasClass('selectedThumbBottom') || liHtml.hasClass('selectedThumbBottomRight') ||
                    liHtml.hasClass('selectedThumbBottomLeft') || liHtml.hasClass('selectedThumbLeft') ||
                    liHtml.hasClass('selectedThumbRight')){
                    var bannerSmallImageUrl = $(this).attr("data-bannerSmallImageUrl");
                    // var url = "url("+bannerSmallImageUrl+")";
                    var url = bannerSmallImageUrl;
                    // $(this).parent('li').removeClass('selectedThumb');
                    // $(this).parent('li').addClass('unSelectedThumb');
                    $(this).parent('li').css({ 'z-index' : ''});
                    var findIndex = vm.selectedThumbnail.indexOf(workCode);
                    if(findIndex !=-1){
                        vm.selectedThumbnail.splice(findIndex,1);
                    }
                    var findIndex = indexList.indexOf($(this).parent().attr("data-index"));
                    if(findIndex !=-1){
                        indexList.splice(findIndex,1);
                    }

                    if(index==0){
                        $(this).parent('li').removeClass('selectedThumbTopLeft');
                        checkcopy.eq($(this).parent().attr("data-index")).removeClass('selectedThumbTopLeft');
                        $(this).parent('li').addClass('unSelectedThumb');
                        checkcopy.eq($(this).parent().attr("data-index")).addClass('unSelectedThumb');
                    }
                    else if(index==totalColumns-1){
                        $(this).parent('li').removeClass('selectedThumbTopRight');
                        checkcopy.eq($(this).parent().attr("data-index")).removeClass('selectedThumbTopRight');
                        $(this).parent('li').addClass('unSelectedThumb');
                        checkcopy.eq($(this).parent().attr("data-index")).addClass('unSelectedThumb');
                    }
                    else if(index>0 && index<totalColumns-1){
                        $(this).parent('li').removeClass('selectedThumbTop');
                        checkcopy.eq($(this).parent().attr("data-index")).removeClass('selectedThumbTop');
                        $(this).parent('li').addClass('unSelectedThumb');
                        checkcopy.eq($(this).parent().attr("data-index")).addClass('unSelectedThumb');
                    }

                    else if(index>totalColumns*(totalRows-1) && index< totalMangas-1){
                        $(this).parent('li').removeClass('selectedThumbBottom');
                        checkcopy.eq($(this).parent().attr("data-index")).removeClass('selectedThumbBottom');
                        $(this).parent('li').addClass('unSelectedThumb');
                        checkcopy.eq($(this).parent().attr("data-index")).addClass('unSelectedThumb');
                    }

                    else if(index==totalMangas-1){
                        $(this).parent('li').removeClass('selectedThumbBottomRight');
                        checkcopy.eq($(this).parent().attr("data-index")).removeClass('selectedThumbBottomRight');
                        $(this).parent('li').addClass('unSelectedThumb');
                        checkcopy.eq($(this).parent().attr("data-index")).addClass('unSelectedThumb');
                    }
                    
                    else if(index/totalColumns==totalRows-1){
                        $(this).parent('li').removeClass('selectedThumbBottomLeft');
                        checkcopy.eq($(this).parent().attr("data-index")).removeClass('selectedThumbBottomLeft');
                        $(this).parent('li').addClass('unSelectedThumb');
                        checkcopy.eq($(this).parent().attr("data-index")).addClass('unSelectedThumb');
                    }

                    else if(index!=0 && index/totalColumns!=totalRows-1 && index%totalColumns == 0){
                        $(this).parent('li').removeClass('selectedThumbLeft');
                        checkcopy.eq($(this).parent().attr("data-index")).removeClass('selectedThumbLeft');
                        $(this).parent('li').addClass('unSelectedThumb');
                        checkcopy.eq($(this).parent().attr("data-index")).addClass('unSelectedThumb');
                    }

                    else if(index!=totalMangas-1 && index!=totalColumns-1 && index%totalColumns == totalColumns-1){
                        $(this).parent('li').removeClass('selectedThumbRight');
                        checkcopy.eq($(this).parent().attr("data-index")).removeClass('selectedThumbRight');
                        $(this).parent('li').addClass('unSelectedThumb');
                        checkcopy.eq($(this).parent().attr("data-index")).addClass('unSelectedThumb');
                    }
                    else{
                        $(this).parent('li').removeClass('selectedThumb');
                        checkcopy.eq($(this).parent().attr("data-index")).removeClass('selectedThumb');
                        $(this).parent('li').addClass('unSelectedThumb');
                        checkcopy.eq($(this).parent().attr("data-index")).addClass('unSelectedThumb');
                    }
                    // checkcopy.eq($(this).parent().attr("data-index")).children().css("background-image", url);
                    checkcopy.eq($(this).parent().attr("data-index")).children().children().attr("src",url)
                    // checkcopy.eq($(this).parent().attr("data-index")).removeClass('selectedThumb');
                    // checkcopy.eq($(this).parent().attr("data-index")).addClass('unSelectedThumb');
                }else{
                    var bannerMonochromeImageUrl = $(this).attr("data-bannerMonochromeImageUrl");
                    
                    // var url = "url("+bannerMonochromeImageUrl+")";
                    var url = bannerMonochromeImageUrl;
                    $(this).parent('li').removeClass('unSelectedThumb');
                    if(index==0){
                        $(this).parent('li').addClass('selectedThumbTopLeft');
                        checkcopy.eq($(this).parent().attr("data-index")).addClass('selectedThumbTopLeft');
                    }
                    else if(index==totalColumns-1){
                        $(this).parent('li').addClass('selectedThumbTopRight');
                        checkcopy.eq($(this).parent().attr("data-index")).addClass('selectedThumbTopRight');
                    }
                    else if(index>0 && index<totalColumns-1){
                        $(this).parent('li').addClass('selectedThumbTop');
                        checkcopy.eq($(this).parent().attr("data-index")).addClass('selectedThumbTop');
                    }

                    else if(index>totalColumns*(totalRows-1) && index< totalMangas-1){
                        $(this).parent('li').addClass('selectedThumbBottom');
                        checkcopy.eq($(this).parent().attr("data-index")).addClass('selectedThumbBottom');
                    }

                    else if(index==totalMangas-1){
                        $(this).parent('li').addClass('selectedThumbBottomRight');
                        checkcopy.eq($(this).parent().attr("data-index")).addClass('selectedThumbBottomRight');
                    }
                    
                    else if(index/totalColumns==totalRows-1){
                        $(this).parent('li').addClass('selectedThumbBottomLeft');
                        checkcopy.eq($(this).parent().attr("data-index")).addClass('selectedThumbBottomLeft');
                    }

                    else if(index!=0 && index/totalColumns!=totalRows-1 && index%totalColumns == 0){
                        $(this).parent('li').addClass('selectedThumbLeft');
                        checkcopy.eq($(this).parent().attr("data-index")).addClass('selectedThumbLeft');
                    }

                    else if(index!=totalMangas-1 && index!=totalColumns-1 && index%totalColumns == totalColumns-1){
                        $(this).parent('li').addClass('selectedThumbRight');
                        checkcopy.eq($(this).parent().attr("data-index")).addClass('selectedThumbRight');
                    }
                    else{
                        $(this).parent('li').addClass('selectedThumb');
                        checkcopy.eq($(this).parent().attr("data-index")).addClass('selectedThumb');
                    }

                    // $(this).parent('li').addClass('selectedThumb');
                    $(this).parent('li').css({ 'z-index' : vm.selectedImagePriority});
                    vm.selectedImagePriority++;
                    vm.selectedThumbnail.push(workCode);
                    indexList.push($(this).parent().attr("data-index"));
                    checkcopy.eq($(this).parent().attr("data-index")).children().children().attr("src",url)
                    // checkcopy.eq($(this).parent().attr("data-index")).children().css("background-image", url);
                    
                    
                    // checkcopy.eq($(this).parent().attr("data-index")).addClass('selectedThumb');
                    
                    
                    checkcopy.eq($(this).parent().attr("data-index")).css({ 'z-index' : vm.selectedImagePriority});
                }
                $(this).children().attr('src',url);
                var noofselectedThumbnail = vm.selectedThumbnail.length;
                $(".calloutImage").attr("src",vm.imageList['topBalloonImage'+noofselectedThumbnail]);
            });
        }

       
    }
</script>

<style>

#image-div {
    width:29%;
}

#button-div {
    width:71%;
}

@media screen and (max-width:768px) {
    .header-content {
        display: none
    }
    .logo {
        float: none;
    }   
    header {
        text-align: center;
    }
    .container{
        padding-right: 0px; 
        padding-left: 0px; 
        margin-right: auto; 
        margin-left: auto; 
        max-width: 100%;
    }
    .btn-custom{
        font-size: 15px;
    }
    /* .selected-thumbnail-right {
        background: #4D4D4D;
        height: 76px;
        text-align: center;
        padding: 19px;
    } */
    
}


@media screen and (max-width:768px) {
    
    #logoImage {
        width: 100px;
        height: 30px;
    }
}

@media screen and (max-width:576px) {
    .btn-custom {
        width:100%;
        font-size: 15px;
    }

    .selected-thumbnail-left img:not(.calloutImage){
        width: 96.5%;
    }
}
@media screen and (max-width:360px) {
    .btn-custom-dialog{
        /* background: black; */
        min-width: 200px;
    }
}


</style>



// WEBPACK FOOTER //
// src/pages/Home.vue